module.exports = __webpack_public_path__ + "eb1797de3b3d76ffaf48e19ddb2d139f.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/flag-sprite.png
// module id = 314
// module chunks = 0